export const types = {


    //* UI */
    startloadingUIPago: '[UI] start loading UI Pago',
    finishloadingUIPago: '[UI] finish loading UI Pago',

    setCompletado: '[UI] set completado',


    //** AUTH
    setIdentificacion: '[AUTH] set identificacion',

    // loadin url de acceso
    startloadingSetURLAcceso: '[AUTH] start loading url acceso',
    finishloadingSetURLAcceso: '[POLIZA] finish loading url acceso',

    // ** POLIZA
    setPoliza: '[POLIZA] set polizas',
    startloadingSetPolizas: '[POLIZA] start loading set polizas',
    finishloadingSetPolizas: '[POLIZA] finish loading set polizas',

    //** PAGAR
    setIdPago: '[PAGAR] set id pago',
    setAllPagarPoliza: '[PAGAR] set all poliza a pagar',
    removeAllPagarPoliza: '[PAGAR] remove all poliza a pagar',
    setCheckAllPagarPoliza: '[PAGAR] set check all poliza a pagar',
    removeCheckAllPagarPoliza: '[PAGAR] remove check all poliza a pagar',
    setCheckPagarPoliza: '[PAGAR] set check poliza a pagar',
    removeCheckPagarPoliza: '[PAGAR] remove poliza a pagar',

    // set email
    setHandleChangeEmail: '[PAGAR] set handle change email',

    // set forma de pago
    setFormaPago: '[PAGAR] set forma pago',

    // Manejar cambio de pago
    setChangePago: '[PAGAR] set handle change pago',

    // ?Manejar cambio data en tarjeta de credito,
    setChangeTarjetaCredito: '[PAGAR] set handle change data tarjeta de credito',
    // ? respuesta de gateway de pago
    setResponseTarjetaCredito: '[PAGAR] set response tarjeta de credito',
    startloadingResponseTarjetaCredito: '[POLIZA] start loading response tarjeta de credito',
    finishloadingResponseTarjetaCredito: '[POLIZA] finish loading response tarjeta de credito',

    // ?Manejar cambio data de yappy
    setHandleChangeYappy: '[PAGAR] set handle change data yappy',

    // ? respuesta de yappy
    startloadingResponseYappy: '[POLIZA] start loading response yappy',
    finishloadingResponseYappy: '[POLIZA] finish loading response yappy',

    // ? respuesta de gateway de pago clave
    setResponseClave: '[PAGAR] set response clave',
    startloadingResponseClave: '[POLIZA] start loading response clave',
    finishloadingResponseClave: '[POLIZA] finish loading response clave',

    // ? loading de proceso de pagos
    startloadingResponseProcesoPago: '[PAGAR] start loading response proceso de pago',
    finishloadingResponseProcesoPago: '[PAGAR] finish loading response pago',
    //* ALERT
    setAlert: '[ALERT] set alert',
    removeAlert: '[ALERT] remove alert'
}